<!--<div class="widgets">-->
<!--  <div><div class="sr-widget sr-widget-1"></div></div>-->

<!--</div>-->
<div class="statistics-modal">
  <div class="title">
    <div class="close" (click)="onNoClick()">X</div>
  </div>
  <iframe [src]="iframe_src" width="100%" height="100%" title=""></iframe>
</div>
